import 'bootstrap/dist/css/bootstrap.min.css';
import Content from './components/Content';
import Footer from './components/Footer';
import NavBar from './components/Navbar';

function App() {
  return (
    <div>
      <NavBar />
      <Content />
      <Footer />
    </div>
  );
}

export default App;
